import { render, staticRenderFns } from "./DevelopmentUnitDetails.vue?vue&type=template&id=073350e1"
import script from "./DevelopmentUnitDetails.vue?vue&type=script&lang=js"
export * from "./DevelopmentUnitDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports